import store from '@/store/index'
import axios from 'axios'
import config from '@/config'
import _ from 'lodash'
import Vue from 'vue'

const debouceMessageDict = {}
const debouceMessage = (msg) => {
  if (!debouceMessageDict[msg]) {
    debouceMessageDict[msg] = _.debounce(() => {
      Vue.prototype.$message.error({
        message: msg,
        showClose: true
      })
    }, 100)
  }
  return debouceMessageDict[msg]
}
const zhongwenRegax = /[\u4e00-\u9fa5]+/
function responseProcess (resp) {
  if (resp.status === 401 || resp.status === 499) {
    store.dispatch('logout')
    return Promise.reject(new Error('未授权的请求, 请登录'))
  } else if (resp.status === 200) {
    if (resp.data.statusCode || resp.data.errorMessage) {
      switch (+resp.data.statusCode) {
        case 200 : return resp.data.data
        case 400 : {
          let message = '请求参数错误'
          if (zhongwenRegax.test(resp.data.errorMessage)) {
            message = resp.data.errorMessage
            debouceMessage(message)()
          }
          return Promise.reject(new Error(message))
        }
        case 401 : {
          debouceMessage('未授权的请求, 请登录')()
          store.dispatch('logout')
          return Promise.reject(new Error('未授权的请求, 请登录'))
        }
        case 403 : {
          debouceMessage('接口无权限')()
          return Promise.reject(new Error('接口无权限'))
        }
        case 499 : {
          debouceMessage('会话已过期，请重新登录')()
          store.dispatch('logout')
          return Promise.reject(new Error('会话已过期，请重新登录'))
        }
        default: {
          Vue.prototype.$message.error({
            message: resp.data.errorMessage,
            duration: 0,
            showClose: true
          })
          return Promise.reject(new Error(resp.data.errorMessage))
        }
      }
    } else if (resp.config.responseType === 'blob') {
      return Promise.resolve(resp)
    } else {
      return Promise.resolve(resp.data)
    }
  } else {
    return Promise.reject(resp.data)
  }
}

const http = axios.create({
  baseURL: config.baseURL
})

http.interceptors.request.use((cfg) => {
  var auth = store.state.auth
  if (auth && auth[config.tokenName]) {
    cfg.headers.Authorization = `${config.tokenType} ${auth[config.tokenName]}`
  }
  if (process.env.NODE_ENV === 'development') {
    if (cfg.url.startsWith('api')) {
      cfg.baseURL = config.serviceZpcAdminDev
    } else {
      cfg.baseURL = config.baseURL
    }
  }
  return cfg
})

http.interceptors.response.use(responseProcess, (err) => {
  if (err.response && (err.response.status === 401 || err.response.status === 499)) {
    store.dispatch('logout')
  } else if (err.response && (err.response.status === 403)) {
    return Promise.reject(new Error('接口无权限'))
  } else if (err.response && (err.response.status >= 400)) {
    debouceMessage(`请求发生错误 错误代码: ${err.response.status}`)()
    return Promise.reject(new Error('请求参数错误'))
  } else {
    debouceMessage('远程服务未连接')()
    return Promise.reject(new Error('远程服务未连接'))
  }
})

export default http
